import { post, get } from "../utils/http";
export default {
  async getOriginalCouponList(param) {
    return await post("/originalCoupon/getOriginalCouponList", param, {
      disibleLoading: true
    });
  },
  async getCouponList(data) {
    return await post("/memberCoupon/couponList", data, {
      disibleLoading: true
    });
  },
  async getCouponMember(data) {
    return await post("/memberCoupon/getMemberCouponList", data, {
      disibleLoading: true
    });
  },
  async getOriginCouponConfig(params) {
    return await get("/generateCoupon/getOriginalCouponConfig", params)
  },
  async getCouponCheck(params) {
    return await get("/generateCoupon/couponCheck", params)
  },
  async getCoupon(params) {
    return await post("/generateCoupon/insertOriginalCoupon", params)
  },
  async getShareCouponConfig(params) {
    return await post("/generateCoupon/getShareCouponConfig", params)
  },
  async checkShareCouponButtonState() {
    return await get("/generateCoupon/checkShareCouponButtonState")
  },
  async updateShareCouponClick(params) {
    return await get("/generateCoupon/updateShareCouponClick", params)
  },
  async insertShareCouponClick(params) {
    return await post("/generateCoupon/insertShareCouponClick", params)
  },
  async getShareCouponCheck(params) {
    return await post("/generateCoupon/getShareCouponCheck", params)
  },
  async lockShareCoupon(params) {
    return await post("/generateCoupon/lockShareCoupon", params, {
      disibleLoading: true
    });
  },
  async checkShareCouponStatus(params) {
    return await post("/generateCoupon/checkShareCouponStatus", params)
  },
  async getRecipientShareCouponConfig(params) {
    return post("/generateCoupon/getRecipientShareCouponConfig", params)
  },
  async saveRecipientCoupon(params) {
    return post("/generateCoupon/saveRecipientCoupon", params)
  },

  checkShareCouponReceived(params) {
    return post("/generateCoupon/checkShareCouponReceived", params)
  },

  checkCouponAvailable(params) {
    return post("/generateCoupon/checkCouponAvailable", params)
  },

  async getCouponDiscountConfig() {
    return await post("/generateCoupon/getPoscodeSetting")
  },
  // UZ_OPE-1917 start
  async getCouponSkuId(params) {
    return await get("/generateCoupon/getCouponSkuId", params)
  },
  // UZ_OPE-1917 end
};
